var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Brugere"}},[_c('toolbar-search-view',{attrs:{"slot":"tools","placeholder":"Brugertype","options":_vm._aqt_role_options},slot:"tools",model:{value:(_vm.filter.role),callback:function ($$v) {_vm.$set(_vm.filter, "role", $$v)},expression:"filter.role"}}),_c('organisations-search-view',{attrs:{"slot":"tools"},slot:"tools",model:{value:(_vm.filter.org),callback:function ($$v) {_vm.$set(_vm.filter, "org", $$v)},expression:"filter.org"}}),_c('toolbar-search-view',{attrs:{"slot":"tools","placeholder":"Rolle","options":_vm._org_role_options},slot:"tools",model:{value:(_vm.filter.org_role),callback:function ($$v) {_vm.$set(_vm.filter, "org_role", $$v)},expression:"filter.org_role"}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Søg","type":"text"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}},slot:"tools"}),_c('button-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools"},on:{"click":_vm.createUser},slot:"tools"},[_vm._v("+ Ny")]),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
		{
			label: 'Navn',
			name: 'name'
		},
		{
			label: 'Brugernavn',
			name: 'username'
		},
		{
			label: 'E-mail',
			name: 'email'
		},
		{
			label: 'Brugertype',
			name: 'role_str'
		},
		{
			label: 'Medlemskaber',
			name: 'memberships_str'
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: '...'
			},
			weight: '100px'
		} ],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext,"delete":_vm.itemContext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }